import React from 'react';
import PropTypes from 'prop-types';
import Picklist from './Picklist';

function MultiPicklist({
  attrName,
  metaField,
  onChange,
  resource,
  SelectProps,
  onInlineSubmit,
  ...rest
}) {
  return (
    <Picklist
      {...rest}
      onChange={onChange}
      metaField={metaField}
      resource={resource}
      attrName={attrName}
      required={metaField.attr('required')}
      SelectProps={{
        ...SelectProps,
        multiple: true,
        MenuProps: {
          ...SelectProps.MenuProps,
          getContentAnchorEl: () => null, // See https://github.com/mui-org/material-ui/issues/19245#issuecomment-620488016
        },
      }}
    />
  );
}

MultiPicklist.defaultProps = {
  disabled: false,
  SelectProps: {},
};

MultiPicklist.propTypes = {
  attrName: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  metaField: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
  SelectProps: PropTypes.object,
};

export default MultiPicklist;
